var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"renewal"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/house/update.gif"),"alt":""}}),_vm._v(" "),_c('p',{staticStyle:{"color":"#6363f0","text-align":"center","font-size":"20px","font-weight":"bold"}},[_vm._v("正在更新中……")])])])
}]

export { render, staticRenderFns }